export default __webpack_public_path__ + "static/media/Logo.3fcd01d7.svg";